import { render, staticRenderFns } from "./alertAdd.vue?vue&type=template&id=7f1385dd&scoped=true&"
import script from "./alertAdd.vue?vue&type=script&lang=js&"
export * from "./alertAdd.vue?vue&type=script&lang=js&"
import style0 from "./alertAdd.vue?vue&type=style&index=0&id=7f1385dd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1385dd",
  null
  
)

export default component.exports